export default __webpack_public_path__ + "static/media/plan-s2.9a2b07ae.svg";